module.exports = __webpack_public_path__ + "9bde851d3b6f29f9be4232ae05beeb65.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/zgyhbxb_c.png
// module id = 815
// module chunks = 3